<template>
  <my-dialog ref="settlementDialog" title="商品销售结算" dialogType="form" :visible.sync="showDialog"
    :close-on-click-modal="false" @close="closeDialog" width="80%">
    <div class="main_bg">
      <div class="item_info">
        <el-descriptions class="margin-top" title="顾客信息" :column="6" border>
          <template slot="extra">
            <el-button type="primary" size="small" icon="el-icon-search"
              @click="showSelectCustomerDialog">选择顾客</el-button>
          </template>
          <el-descriptions-item>
            <template slot="label">
              <i class="el-icon-user"></i>
              顾客姓名
            </template>
            {{ transformEmpty(customerInfo.name) }}
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">
              <i class="el-icon-office-building"></i>
              性别
            </template>
            {{ transformGender(customerInfo.gender) }}
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">
              <i class="el-icon-tickets"></i>
              年龄
            </template>
            {{ transformEmpty(customerInfo.age) }}
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">
              <i class="el-icon-mobile-phone"></i>
              顾客电话
            </template>
            {{ transformEmpty(customerInfo.phone) }}
          </el-descriptions-item>
          <el-descriptions-item span="3">
            <template slot="label">
              <i class="el-icon-location-outline"></i>
              所属门店
            </template>
            {{ transformEmpty(customerInfo.belongStoreName) }}
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">
              <i class="el-icon-tickets"></i>
              (右眼)球镜
            </template>
            {{ transformEmpty(customerInfo.rParams.qiuJing) }}
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">
              <i class="el-icon-tickets"></i>
              柱镜
            </template>
            {{ transformEmpty(customerInfo.rParams.zhuJing) }}
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">
              <i class="el-icon-tickets"></i>
              轴位
            </template>
            {{ transformEmpty(customerInfo.rParams.zhouWei) }}
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">
              <i class="el-icon-tickets"></i>
              矫正视力
            </template>
            {{ transformEmpty(customerInfo.rParams.jiaoZhengShiLi) }}
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">
              <i class="el-icon-tickets"></i>
              瞳距
            </template>
            {{ transformEmpty(customerInfo.rParams.tongJu) }}
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">
              <i class="el-icon-tickets"></i>
              瞳高
            </template>
            {{ transformEmpty(customerInfo.rParams.tongGao) }}
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">
              <i class="el-icon-tickets"></i>
              (左眼)球镜
            </template>
            {{ transformEmpty(customerInfo.lParams.qiuJing) }}
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">
              <i class="el-icon-tickets"></i>
              柱镜
            </template>
            {{ transformEmpty(customerInfo.lParams.zhuJing) }}
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">
              <i class="el-icon-tickets"></i>
              轴位
            </template>
            {{ transformEmpty(customerInfo.lParams.zhouWei) }}
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">
              <i class="el-icon-tickets"></i>
              矫正视力
            </template>
            {{ transformEmpty(customerInfo.lParams.jiaoZhengShiLi) }}
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">
              <i class="el-icon-tickets"></i>
              瞳距
            </template>
            {{ transformEmpty(customerInfo.lParams.tongJu) }}
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">
              <i class="el-icon-tickets"></i>
              瞳高
            </template>
            {{ transformEmpty(customerInfo.lParams.tongGao) }}
          </el-descriptions-item>
        </el-descriptions>
      </div>
      <div class="item_info border_Green" v-if="vipInfo.keyId">
        <el-descriptions class="margin-top" title="会员信息" :column="3" border>
          <el-descriptions-item>
            <template slot="label">
              <i class="el-icon-user"></i>
              会员卡号
            </template>
            {{ vipInfo.vipNo }}
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">
              <i class="el-icon-user"></i>
              会员类型
            </template>
            {{ customerInfo.customerTypeStr }}
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">
              <i class="el-icon-user"></i>
              会员卡余额
            </template>
            <span style="width: 100px; display: inline-block; color: red;font-weight: bold;font-size: 16px;"> {{
              vipInfo.balance }}</span>
          </el-descriptions-item>
        </el-descriptions>
      </div>
      <div class="item_info border_Warningcolor">
        <el-descriptions class="margin-top" title="订单信息" :column="3" border>
          <template slot="extra">
            <!--是否第二方式支付-->
            是否第二方式支付：<el-switch v-model="saleInfo.isSecondPay" :active-value="true" :inactive-value="false"
              active-text="是" inactive-text="否" @change="handleSecondPayChange" />
          </template>
          <el-descriptions-item>
            <template slot="label">
              <i class="el-icon-mobile-phone"></i>
              所属门店
            </template>
            <el-select v-model="saleInfo.storeKeyId" placeholder="请选择所属门店" filterable size="small" style="width: 100%;"
              @change="handleSelectStore">
              <el-option v-for="item in storeList" :key="item.keyId" :label="item.name" :value="item.keyId" />
            </el-select>
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">
              <i class="el-icon-mobile-phone"></i>
              订单来源
            </template>
            <el-select v-model.number="saleInfo.orderSource" placeholder="请选择订单来源" clearable filterable size="small"
              style="width: 100%;" @change="handleSelectOrderSource">
              <el-option v-for="item in orderSourceList" :key="item.code" :label="item.name" :value="item.code" />
            </el-select>
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">
              <i class="el-icon-mobile-phone"></i>
              商品数量
            </template>
            <span style="width: 100px; display: inline-block;"> {{ totalQuantity }}</span>
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">
              <i class="el-icon-mobile-phone"></i>
              商品总金额
            </template>
            <span style="width: 100px; display: inline-block;font-weight: bold;font-size: 16px; color: red;"> ￥{{
              totalGoodsMoney }}元</span>
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">
              <i class="el-icon-mobile-phone"></i>
              订单总金额
            </template>
            <el-input-number v-model.number="saleInfo.totalMoney" placeholder="请输入订单总金额" size="small"
              style="width: 100%;" min="0" step="0.01" :precision="2" />
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">
              <i class="el-icon-mobile-phone"></i>
              电话邀约人
            </template>
            <el-select v-model="saleInfo.phonePnvitation" placeholder="请选择电话邀约人" filterable size="small"
              style="width: 100%;">
              <el-option v-for="item in userList" :label="item.value" :value="item.keyId" :key="item.keyId"></el-option>
            </el-select>
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">
              <i class="el-icon-mobile-phone"></i>
              支付方式
            </template>
            <el-select v-model.number="saleInfo.payType.payTypeId" placeholder="请选择支付方式" filterable size="small"
              style="width: 100%;">
              <el-option v-for="item in payTypeList" :label="item.payTypeName" :value="item.payTypeId"
                :key="item.payTypeId"></el-option>
            </el-select>
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">
              <i class="el-icon-mobile-phone"></i>
              支付金额
            </template>
            <el-input-number v-model.number="saleInfo.payType.payMoney" placeholder="请输入支付金额" style="width: 100%;"
              :min="0" :step="0.01" :precision="2" size="small"></el-input-number>
          </el-descriptions-item>
          <el-descriptions-item span="3">
            <template slot="label">
              <i class="el-icon-mobile-phone"></i>
              支付备注
            </template>
            <el-input v-model="saleInfo.payType.payComment" placeholder="请输入支付备注" style="width: 100%;"
              size="small"></el-input>
          </el-descriptions-item>


          <el-descriptions-item v-if="saleInfo.isSecondPay">
            <template slot="label">
              <i class="el-icon-mobile-phone"></i>
              第二种方式支付
            </template>
            <el-select v-model.number="saleInfo.secondPayType.payTypeId" placeholder="请选择第二种方式支付方式" filterable size="small"
              style="width: 100%;">
              <el-option v-for="item in payTypeList" :label="item.payTypeName" :value="item.payTypeId"
                :key="item.payTypeId"></el-option>
            </el-select>
          </el-descriptions-item>
          <el-descriptions-item v-if="saleInfo.isSecondPay">
            <template slot="label">
              <i class="el-icon-mobile-phone"></i>
              第二种方式支付金额
            </template>
            <el-input-number v-model.number="saleInfo.secondPayType.payMoney" placeholder="请输入第二种方式支付支付金额"
              style="width: 100%;" :min="0" :step="0.01" :precision="2" size="small"></el-input-number>
          </el-descriptions-item>
          <el-descriptions-item span="3" v-if="saleInfo.isSecondPay">
            <template slot="label">
              <i class="el-icon-mobile-phone"></i>
              第二种方式支付备注
            </template>
            <el-input v-model="saleInfo.secondPayType.payComment" placeholder="请输入第二种方式支付支付备注" style="width: 100%;"
              size="small"></el-input>
          </el-descriptions-item>


          <el-descriptions-item span="4">
            <template slot="label">
              <i class="el-icon-mobile-phone"></i>
              订单备注
            </template>
            <el-input v-model="saleInfo.remark" placeholder="请输入订单备注" type="textarea" clearable :rows="2" />
          </el-descriptions-item>
        </el-descriptions>
      </div>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button size="small" icon="el-icon-close" @click="closeDialog">取消</el-button>
      <el-button size="small" type="primary" icon="el-icon-check" :loading="saveloading" class="title"
        @click="handleSubmitSalesOrder()">
        保存
      </el-button>
    </div>
  </my-dialog>
</template>
<script>
import { getCustomerInfoDetail } from "@/api/baseDataApi.js";
import { GetOrgInfoListByConfig } from "@/api/organizationalApi.js";
import { GetEnumConfigListByCode } from "@/api/enumApi.js";
import {
  SaveSalesOrder,
} from "@/api/productApi.js";
import {
  GetUserBindSelectByPermission
} from "@/api/userApi.js";
import {
  GetCustomerVipInfoByKeyId
} from "@/api/baseDataApi.js";
export default {
  props: [],
  data() {
    return {
      showDialog: false,
      saveloading: false,
      storeList: [],
      customerInfo: {
        name: "",
        phone: "",
        age: "",
        gender: -1,
        belongStoreName: "",
        lParams: {
          qiuJing: "",
          zhuJing: "",
          zhouWei: 0,
          jiaoZhengShiLi: "",
          tongJu: "",
          tongGao: "",
        },
        rParams: {
          qiuJing: "",
          zhuJing: "",
          zhouWei: 0,
          jiaoZhengShiLi: "",
          tongJu: "",
          tongGao: "",
        },
      },
      orderSourceList: [],
      saleInfo: {
        payType: {
          payTypeId: 1,
          payMoney: 0,
          payComment: "",
        },
        isSecondPay: false,
        secondPayType: {
          payTypeId: 1,
          payMoney: 0,
          payComment: "",
        },
        customerKeyId: "",
        dtls: [],
        storeKeyId: "",
        totalMoney: 0,
        totalPayMoney: 0,
        orderSource: 1,
        remark: "",
        phonePnvitation: "",
      },
      userList: [],
      payTypeList: [],
      vipInfo: {},
      totalQuantity: 0,
      totalGoodsMoney: 0,
      isSubmitting: false,
      listSelectedGoods: [],
    };
  },
  computed: {},
  watch: {},
  components: {},
  created() {
    this.GetOrgInfoListByConfig();
    this.getOrderSource();
    this.GetPayTypeListByCode();
  },
  methods: {
    // 显示
    showSettlementDialog(saleInfo) {
      this.showDialog = true;
      this.totalQuantity = saleInfo.totalQuantity;
      this.totalGoodsMoney = saleInfo.totalMoney;
      this.listSelectedGoods = saleInfo.listSelectedGoods;
      this.saleInfo = {
        payType: {
          payTypeId: 1,
          payMoney: 0,
          payComment: "",
        },
        isSecondPay: false,
        secondPayType: {
          payTypeId: 1,
          payMoney: 0,
          payComment: "",
        },
        customerKeyId: "",
        dtls: [],
        storeKeyId: saleInfo.storeKeyId,
        totalMoney: saleInfo.totalMoney,
        totalPayMoney: 0,
        orderSource: 1,
        remark: "",
      };
      this.GetUserBindSelectByPermission();
    },
    //获取支付类型信息
    GetPayTypeListByCode() {
      const paramer = {
        code: "PayType",
      };
      GetEnumConfigListByCode(paramer)
        .then((res) => {
          if (res.code == 1) {
            this.payTypeList = [];
            res.data.forEach((item) => {
              this.payTypeList.push({
                payTypeId: parseInt(item.code),
                payTypeName: item.name,
              });
            });
          } else {
            this.$message.error(res.msg);
          }
        })
        .catch((err) => {
          this.loading = false;
          this.$message.error("获取状态信息失败!");
        });
    },
    // 获取员工列表信息
    GetUserBindSelectByPermission() {
      if (!this.saleInfo.storeKeyId) {
        this.$message.error("请选择门店！");
        return;
      }
      GetUserBindSelectByPermission({
        keyId: this.saleInfo.storeKeyId
      })
        .then((res) => {
          if (res.code == 1) {
            this.userList = res.data;
          } else {
            this.$message.error(res.msg);
          }
        })
        .catch((err) => {
          this.$message.error("获取员工列表失败，请稍后再试！");
        });
    },
    // 处理提交支付
    handleSubmitSalesOrder() {
      if (!this.saleInfo.customerKeyId) {
        this.$message.error("请选择客户！");
        return;
      }
      if (!this.saleInfo.storeKeyId) {
        this.$message.error("请选择门店！");
        return;
      }
      if (!this.saleInfo.payType.payTypeId) {
        this.$message.error("请选择支付类型！");
        return;
      }
      if (!this.saleInfo.payType.payMoney && this.saleInfo.orderSource !== 3 && this.saleInfo.orderSource !== 7) {
        this.$message.error("请输入支付金额！");
        return;
      }
      this.isSubmitting = true;
      var products = [];
      this.listSelectedGoods.forEach((item) => {
        products.push({
          storeProductKeyId: item.keyId,
          quantity: item.quantity
        });
      });
      this.saleInfo.dtls = products;
      SaveSalesOrder(this.saleInfo)
        .then((res) => {
          if (res.code == 1) {
            this.$message.success("支付成功！");
            this.closeDialog();
            this.$parent.clearSelectedGoods();
          } else {
            this.$message.error(res.msg);
          }
        })
        .catch((err) => {
          this.$message.error("支付失败，请稍后再试！");
        })
        .finally(() => {
          this.isSubmitting = false;
        });
    },
    // 获取所属门店
    GetOrgInfoListByConfig() {
      const paramer = {
        key: 1,
      };
      GetOrgInfoListByConfig(paramer)
        .then((res) => {
          if (res.code == 1) {
            this.storeList = res.data;
          } else {
            this.$message.error(res.msg);
          }
        })
        .catch((err) => {
          this.loading = false;
          this.$message.error("获取门店信息失败!");
        });
    },
    // 选择门店
    handleSelectStore(val) {
      this.saleInfo.storeKeyId = val;
    },
    // 选中顾客
    submitSelect(selectionKeyId) {
      this.saleInfo.customerKeyId = selectionKeyId;
      let params = {
        keyId: selectionKeyId,
      };
      getCustomerInfoDetail(params).then((res) => {
        if (res.code == 1) {
          this.customerInfo = res.data;

          GetCustomerVipInfoByKeyId({
            keyId: selectionKeyId,
          }).then((resVip) => {
            if (resVip.code == 1) {
              this.vipInfo = resVip.data;
            } else {
              this.$message({
                type: "error",
                message: resVip.msg,
              });
            }
          });
        } else {
          this.$message({
            type: "error",
            message: res.msg,
          });
        }
      });
    },
    //转换性别
    transformGender(gender) {
      if (gender == 1) {
        return "男";
      } else if (gender == 0) {
        return "女";
      } else {
        return "--";
      }
    },
    // 关闭
    closeDialog() {
      this.saleInfo = this.$options.data.call(this).saleInfo;
      this.customerInfo = {
        name: "",
        phone: "",
        age: "",
        gender: -1,
        belongStoreName: "",
        lParams: {
          qiuJing: "",
          zhuJing: "",
          zhouWei: 0,
          jiaoZhengShiLi: "",
          tongJu: "",
          tongGao: "",
        },
        rParams: {
          qiuJing: "",
          zhuJing: "",
          zhouWei: 0,
          jiaoZhengShiLi: "",
          tongJu: "",
          tongGao: "",
        },
      };
      this.showDialog = false;
    },
    //判断为空则用 -- 替代
    transformEmpty(obj) {
      if (obj == "" || obj == null || obj == undefined) {
        obj = "--";
      }
      return obj;
    },
    // 展示选择顾客弹窗
    showSelectCustomerDialog() {
      this.$parent.showSelectCustomerDialog();
    },
    // 获取订单来源
    getOrderSource() {
      GetEnumConfigListByCode({
        code: "StoreOrderSource",
      })
        .then((res) => {
          if (res.code == 1) {
            this.orderSourceList = [];
            res.data.forEach(item => {
              this.orderSourceList.push({
                code: parseInt(item.code),
                name: item.name,
              })
            });
          } else {
            this.$message.error(res.msg);
          }
        })
        .catch((err) => {
          this.$message.error("获取加工类型失败!");
        });
    },
    // 选择订单来源
    handleSelectOrderSource(val) {
      this.saleInfo.orderSource = val;
    },
    handleSecondPayChange(val) {

    }
  },
};
</script>
<style scoped lang="scss">
.main_bg {
  padding: 10px;
  margin-top: -15px;
}

.item_info {
  border-left: 5px solid #55aaff;
  padding: 5px 10px;
  border-radius: 5px;
  margin-bottom: 15px;
  border-bottom: 2px solid #e9e7e7;
}

.border_Warningcolor {
  border-left: 5px solid #ff9900;
}

.border_Green {
  border-left: 5px solid #00cc66;
}

.item_title {
  display: flex;
  width: 100%;
  font-weight: 700;
  font-size: 1rem;
  margin-bottom: 10px;
  justify-content: space-between;

  .title {
    display: inline-block;
    unicode-bidi: isolate;
  }

  .btnDiv {
    display: block;
    unicode-bidi: isolate;
    word-break: break-all;
  }
}
</style>